module.exports = __webpack_public_path__ + "img/tbwk.1a1d13c2.png";